module.exports = __webpack_public_path__ + "static/media/car4.d8adfe26.gif";